(function () {
  'use strict';
  angular
    .module('andeanFront', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr',
      'LocalStorageModule', 'angular-inview', 'ngMap', 'fox.scrollReveal', 'angularSmoothscroll', 'angular-owl-carousel-2']);

})();

'use strict';
angular
  .module('andeanFront')
  .factory('TablesService', function ($http, $rootScope) {
    return {
      listar: function (tabla) {
        var params = [];
        params['lan'] = 'en';
        return $http.get($rootScope.api + '/api/' + tabla, params);
      },
      filtrar: function (tabla, params) {
        params['lan'] = 'en';
        return $http.post($rootScope.api + '/api/' + tabla + '/filtrar', params);
      },
      contactar: function (params) {
        params['lan'] = $rootScope.language != undefined ? $rootScope.language : 'en';
        return $http.post($rootScope.api + '/api/formcontacto/almacenar', params);
      },
      visualizar: function (tabla, id) {
        var params = {
          'token': $rootScope.tk,
          'lan': $rootScope.language != undefined ? $rootScope.language : 'en'
        };
        return $http.get($rootScope.api + '/api/' + tabla + '/visualizar/' + id, params);
      }
    };
  });

(function () {
  'use strict';
  angular
    .module('andeanFront')
    .directive('mapd3', function ($filter, $log, $rootScope) {
      return {
        //define the directive object
        controller: 'Mapd3Controller',
        restrict: 'AC',//restrict to attribute and class
        controllerAs: 'mapCtrl',
        scope: {},
        link: function (scope, element, attrs) {

          var newheight = element.width() * 0.664;

          var scale = (element.width() * 156) / 1024;
          var percentage = element.width() / 1080;
          console.log(percentage, scale);

          element.height(newheight);
          var width = element.width(),
            height = element.height(),
            centered;

          angular.element('#marco_mapa').attr('transform', 'scale(' + percentage + ') translate(2, 16)');

          var textHover = angular.element('.speech-bubble');

          var projection = d3.geoMercator()
            .scale(scale)
            .center([0, 45])
            .translate([width / 2, height / 2]);

          var path = d3.geoPath()
            .projection(projection);

// Set svg width & height
          var svg = d3.select("." + attrs.class)
            .select("svg")
            .attr("width", width)
            .attr("height", height)
            .append("g");
          //.attr("transform", "translate("+(width/2)+","+(height/2)+")");

          var g = svg.append('g');

          var mapLayer = g.append('g')
            .classed('map-layer', true);

          /*g.append("text")
          .attr("fill", "black")
          .attr("text-anchor", "middle")
          .attr("transform", "translate(" + 0 + "," + height + ")")
          .style("font-size", "8pt");*/

// Load map data
          d3.json('assets/resources/countries.geo.json', function (error, mapData) {
            if (mapData != undefined) {
              makeMap(mapData.features);
            }
          });


          //scope.$watch('countries', function (newValue, oldValue) {
          $rootScope.countries_render = function (newValue) {
            console.log("watch countries", newValue);
            updateMap(newValue);
            //});
          }


          function updateMap() {
            mapLayer.selectAll('path').each(function (d, i) {
              d3.select(this).style('fill', filled(d));
            });
          }

          function makeMap(features) {
            mapLayer.selectAll('path')
              .data(features)
              .enter().append('path')
              .attr('d', path)
              .attr('vector-effect', 'non-scaling-stroke')
              .attr('class', addClass)
              .style('fill', function (d) {
                return filled(d);
              })
              .on('mouseover', mouseover)
              .on('mouseout', mouseout)
              .on('click', mouseover);
          }

          function mouseover(d) {

            var iso = d.properties.iso_a3;
            var country_finded = $rootScope.findCountryByIso(iso);
            if (country_finded.length > 0) {
              var category_finded = $rootScope.findCategories(country_finded[0].category);

              var centroid = path.centroid(d);
              var x = centroid[0] - 16;
              var y = centroid[1] - 80;
              console.log(x, y);


              category_finded = category_finded.length > 0 ? category_finded[0].name : '';

              textHover.css('left', x).css('top', y).addClass("show");
              textHover.find('.country').text(country_finded[0].name);
              textHover.find('.category').text(category_finded);
            }

            if (d3.select(this).classed('selected')) {
              $('.country.selected').css('opacity', .32);
              $('.country-' + iso).css('opacity', 1);
            }
          }


          function mouseout(d) {
            //textHover.removeClass("show");
          }

          function filled(d) {
            var finded = false;
            var curr_index = 0;
            var iso = d.properties.iso_a3;

            var country_finded = $rootScope.findCountryByIso(iso);
            if (country_finded.length > 0) {
              console.log(iso);
            }

            var color = country_finded.length > 0 ? $rootScope.colors(country_finded[0].category) : '#EADBC2';
            return color;
          }

          function addClass(d) {
            var country_code = d.properties.iso_a3;

            return 'country country-' + country_code;
          }

          function posX(d) {
            var response = 0;
            if (d['Country Code'] != undefined) {
              var id = '#country-' + d['Country Code'];
              var country_select = d3.select(id);
              var element = country_select.node();
              // use the native SVG interface to get the bounding box
              var bbox = element.getBBox();

              response = bbox.x + (bbox.width / 2);
              console.log(response);
            }
            return response;
          }

          function posY(d) {
            var response = 0;
            if (d['Country Code'] != undefined) {
              var id = '#country-' + d['Country Code'];
              var country_select = d3.select(id);
              var element = country_select.node();
              // use the native SVG interface to get the bounding box
              var bbox = element.getBBox();

              response = bbox.y + (bbox.height / 2);
              console.log(response);
            }
            return response;
          }

// When clicked, zoom in
          function clicked(d) {
            var x, y, k;

            if (d) {
              $rootScope.country_update(d.properties.iso_a3);
            }
            // Compute centroid of the selected path
            if (d && centered !== d) {
              var centroid = path.centroid(d);
              x = centroid[0];
              y = centroid[1];
              k = 1.6;
              centered = d;
              d3.select(this).classed('selected', true);
            } else {
              x = width / 2;
              y = height / 2;
              k = 1;
              centered = null;
              d3.select(this).classed('selected', false);
            }

            // Zoom
            g.transition()
              .duration(750)
              .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')scale(' + k + ')translate(' + -x + ',' + -y + ')');
          }

        }
      }
    })
    .controller('Mapd3Controller', function ($log, $rootScope) {
      var vm = this;
      $log.debug('Mapd3Controller');
    });

})();

(function () {
  'use strict';
  angular
    .module('andeanFront')
    .directive("countTo", ["$timeout", function (a) {
      return {
        replace: !1, scope: !0, link: function (b, c, d) {
          var e, f, g, h, i, j, k, l = c[0], m = function () {
            f = 30, i = 0, b.timoutId = null, j = parseInt(d.countTo) || 0, b.value = parseInt(d.value, 10) || 0, g = 1e3 * parseFloat(d.duration) || 0, h = Math.ceil(g / f), k = (j - b.value) / h, e = b.value
          }, n = function () {
            b.timoutId = a(function () {
              e += k, i++, i >= h ? (a.cancel(b.timoutId), e = j, l.innerText = j) : (l.innerText = Math.round(e), n())
            }, f)
          }, o = function () {
            b.timoutId && a.cancel(b.timoutId), m(), n()
          };
          return d.$observe("countTo", function (a) {
            a && o()
          }), d.$observe("value", function () {
            o()
          }), !0
        }
      }
    }])
    .directive('height100', function ($log) {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $log.debug('Aplicando directiva height');
          $(window).resize(function () {
            element.css({"height": $(window).height()});
          }).resize();
        }
      };
    })
    .directive('listaMenu', function ($log) {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $(window).resize(function () {
            if ($(window).width() < 779) {
              element.css({"maxHeight": $(window).height() - 60});
            } else {
              element.css({"maxHeight": 'none'});
            }
          }).resize();
        }
      };
    })
    .directive('proporcion', function ($log, $timeout) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var conf = scope.$eval(attrs.proporcion);
          //$log.debug('Config', conf);
          var calcProp = function () {
            if ((!conf.desde && !conf.hasta) || ($(window).width() > conf.desde && $(window).width() <= conf.hasta)) {
              var eW = element[0].getBoundingClientRect().width;
              var nW = eW / conf.ancho;
              var nH = nW * conf.alto;
              element.css('height', nH + 'px');
            } else {
              if (conf.default) {
                element.css('height', conf.default + 'px');
              } else {
                element.css('height', 'initial');
              }
            }
          };
          $timeout(function () {
            calcProp();
          }, 10);
          angular.element(window).resize(function () {
            $timeout(function () {
              calcProp();
            }, 10);
          });
        }
      };
    })
    .controller('indDropDownCtrl', function ($log, $timeout, $scope) {
      $scope.hideDesp = function () {
        $timeout(function () {
          $scope.showDesp = false;
        }, 30);
        $scope.showDesp = false;
      };
      $scope.selOpcion = function (elem) {
        $scope.opselected = elem;
        $timeout(function () {
          $scope.onselect();
          $scope.hideDesp();
        }, 30);
      };
    })
    .directive('igualar2', function ($log, $timeout) {
      return {
        restrict: 'C',
        link: function (scope, element, attrs) {
          var igualar = function () {
            var eH = 0;
            var col = '';
            if (element.children('.izq')[0].getBoundingClientRect().height > element.children('.der')[0].getBoundingClientRect().height) {
              eH = element.children('.izq')[0].getBoundingClientRect().height;
              col = element.children('.der')[0];
            } else {
              eH = element.children('.der')[0].getBoundingClientRect().height;
              col = element.children('.izq')[0];
            }
            if ($(window).width() > 992) {
              col.style.height = eH + 'px';
            } else {
              element.children('.izq')[0].style.height = 'auto';
              element.children('.der')[0].style.height = 'auto';
            }
          };
          $timeout(function () {
            igualar();
          }, 30);
          angular.element(window).resize(function () {
            $timeout(function () {
              igualar();
            }, 30);
          });
        }
      };
    })
    .directive('indDropDown', function ($log, $timeout, $compile) {
      return {
        restrict: 'C',
        controller: 'indDropDownCtrl',
        scope: {
          opciones: "=",
          onselect: "&",
          opselected: "=",
          txdefault: "@",
          campotx: "@"
        },
        link: function (scope, element, attrs) {
          var template = '<div class="ind-desplegable" deep-blur="hideDesp();">' +
            '<label class="deplegar-lista" data-ng-click="showDesp = !showDesp" data-ng-class="{active: showDesp}">' +
            '<a><span data-ng-if="!opselected" data-ng-bind="txdefault" class="dropdown-placeholder"></span>' +
            '<span data-ng-if="opselected" data-ng-bind="opselected[campotx]"></span></a><span></span></label>' +
            '<ul data-ng-if="showDesp" class="lista-elegir">' +
            '<li data-ng-repeat="d in opciones" data-ng-click="selOpcion(d);"><span data-ng-bind="d[campotx]"></span></li></ul></div>';
          var content = $compile(template)(scope);
          element.replaceWith(content);
          /*attrs.$observe('opselected', function (val) {
           element.replaceWith(content);
           });*/
        }
      };
    })
    .directive('indDropDownClean', function ($log, $timeout, $compile) {
      return {
        restrict: 'C',
        controller: 'indDropDownCtrl',
        scope: {
          opciones: "=",
          onselect: "&",
          opselected: "=",
          txdefault: "@",
          campotx: "@"
        },
        link: function (scope, element, attrs) {
          var template = '<div class="ind-desplegable" deep-blur="hideDesp();">' +
            '<label class="deplegar-lista" data-ng-click="showDesp = !showDesp" data-ng-class="{active: showDesp}">' +
            '<a><span data-ng-if="!opselected" data-ng-bind="txdefault"></span>' +
            '<span data-ng-if="opselected" data-ng-bind="opselected[campotx]"></span></a><span></span></label>' +
            '<ul data-ng-if="showDesp" class="lista-elegir">' +
            '<li data-ng-repeat="d in opciones" data-ng-click="selOpcion(d);"><span data-ng-bind="d"></span></li></ul></div>';
          var content = $compile(template)(scope);
          element.replaceWith(content);
          /*attrs.$observe('opselected', function (val) {
           element.replaceWith(content);
           });*/
        }
      };
    })
    .directive('deepBlur', ['$timeout', function ($timeout) {
      return {
        restrict: 'A',
        controller: ['$scope', '$element', '$attrs', '$log', function ($scope, $element, $attrs, $log) {
          function containsDom(parent, dom) {
            while (dom) {
              if (dom === parent) {
                return true;
              }
              dom = dom.parentNode;
            }
            return false;
          }

          var leaveExpr = $attrs.deepBlur,
            dom = $element[0];

          function onBlur(e) {
            var targetElement = e.relatedTarget || document.activeElement;
            if (!containsDom(dom, targetElement)) {
              $timeout(function () {
                $scope.$apply(leaveExpr);
              }, 30);
            }
          }

          if (dom.addEventListener) {
            dom.addEventListener('blur', onBlur, true);
          } else {
            dom.attachEvent('onfocusout', onBlur);
          }
        }]
      };
    }])
    .directive('pagina', function ($log, $timeout) {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $(window).resize(function () {
            if ($(window).width() > 992) {
              element.css({minHeight: $(window).height() - 60});
            } else {
              $timeout(function () {
                element.css({minHeight: $(window).height() - $('.footer').height() - 30});
              }, 30);
            }
          }).resize();
        }
      };
    })
    .directive('paisfull', function () {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $(window).resize(function () {
            if ($(window).width() > 992) {
              element.css({minHeight: $(window).height() - 387});
              element.children('.fondo').css({minHeight: $(window).height() - 387});
            } else {
              element.css({minHeight: $(window).height() - 357});
              element.children('.fondo').css({minHeight: $(window).height() - 387});
            }
          }).resize();
        }
      };
    })
    .directive('contIgualar', function ($log, $timeout) {
      return {
        restrict: 'C',
        scope: {
          elementos: "@",
          columnas: "@",
          reload: "@",
          maxheight: "@"
        },
        link: function (scope, element, attrs) {
          //var elems = document.getElementsByClassName(scope.elementos);
          var columnas = parseInt(scope.columnas);
          var igualar = function () {
            if ($(window).width() > 768) {
              $timeout(function () {
                var elems = element.children('.' + scope.elementos);
                var eigualar = [];
                for (var i = 1; i <= elems.length; i++) {
                  if (i % columnas == 0) {
                    eigualar.push(elems[i - 1]);
                    var mh = 0;
                    angular.forEach(eigualar, function (value, key) {
                      if (value.getBoundingClientRect().height > mh) {
                        if (scope.maxheight) {
                          mh = value.getBoundingClientRect().width - (value.getBoundingClientRect().width / 10);
                        } else {
                          mh = value.getBoundingClientRect().height;
                        }
                      }
                    });
                    angular.forEach(eigualar, function (value, key) {
                      value.style.height = mh + "px";
                    });
                    eigualar = []
                  } else {
                    eigualar.push(elems[i - 1]);
                  }
                }
                var mh2 = 0;
                angular.forEach(eigualar, function (value, key) {
                  if (value.getBoundingClientRect().height > mh2) {
                    mh2 = value.getBoundingClientRect().height;
                  }
                });
                angular.forEach(eigualar, function (value, key) {
                  value.style.height = mh2 + "px";
                });
              }, 30);
            }
          };
          angular.element(window).resize(function () {
            var elems = element.children('.' + scope.elementos);
            angular.forEach(elems, function (value, key) {
              value.style.height = "initial";
            });
            igualar();
          });
          igualar();
          var reigualar = function () {
            var elems = element.children('.' + scope.elementos);
            angular.forEach(elems, function (value, key) {
              value.style.height = "initial";
            });
            $timeout(function () {
              $log.debug('Volviendo a igualar');
              igualar();
            }, 30);
          };
          if (scope.reload) {
            //$log.debug('Volver a igualar');
            var imageswait = element.find("img");
            $log.debug('cantidad de imagenes', imageswait);
            var countload = 0;
            angular.forEach(imageswait, function (value, key) {
              value.onload = function () {
                //$log.debug('Imagen '+key+' cargada');
                countload++;
                if (countload == imageswait.length) {
                  reigualar();
                }
              };
            });
          }
        }
      }
    })
    .directive('paginaprod', function ($log, $timeout) {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({height: $(window).height() - 60});
            element.css({paddingTop: 70});
            element.css({overflowY: "scroll"});
          }).resize();
        }
      };
    })
    .directive('topHeight', function () {
      return {
        restrict: 'A',

        scope: {
          type2: '@',
        },
        link: function (scope, element) {
          $(window).resize(function () {
            if ($(window).width() >= 768) {
              var heigth = Math.round(($(window).height() / 3) - ((130 / 3)) - 1);
              element.css({minHeight: heigth * 2});
              if (scope.type2 && $(window).width() < 992) {
                element.css({minHeight: 100});
              }
            }
            else {
              element.css({minHeight: 100});
            }
          }).resize();
        }
      };
    })
    .directive('bottomHeight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {

          $(window).resize(function () {
            var heigth = Math.round(($(window).height() / 3) - ((130 / 3)));
            //element.css({minHeight: heigth * 1});
            if ($(window).width() >= 768) {
              element.css({minHeight: heigth * 1});
            }
            else {
              element.css({minHeight: 320});
            }
          }).resize();
        }
      };
    })
    .directive('bottomHeight2', function () {
      return {
        restrict: 'A',
        scope: {
          background: '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var heigth = Math.round(($(window).height() / 3) - ((130 / 3)));

            element.css({background: "url('" + scope.background + "')"});
            element.css({backgroundSize: "cover"});
            element.css({backgroundPosition: "center"});
            if ($(window).width() >= 768) {
              element.css({minHeight: heigth * 1});
            }
            else {
              element.css({minHeight: 320});
            }
          }).resize();
        }
      };
    })
    .directive('videoYt', function ($log, $timeout, $compile) {
      return {
        restrict: 'C',
        scope: {
          urlyt: "@"
        },
        link: function (scope, element, attrs) {
          $timeout(function () {
            var template = '<path d="' + scope.urlyt + '"/>';
            var content = $compile(template)(scope);
            element.replaceWith(content);
          }, 100);
        }
      };
    })
    .filter('trusted', ['$sce', function ($sce) {
      return function (url) {
        var video_id = url;
        return $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + video_id);
      };
    }]);
})();

'use strict';
angular
  .module('andeanFront')
  .controller('SuppliersController', function ($log, TablesService, $timeout) {
    var vm = this;
    $log.debug('SuppliersController');
  })
  .controller('TraceabilityController', function ($log, TablesService, $timeout) {
    var vm = this;
    $log.debug('TraceabilityController');
  });

'use strict';
angular
  .module('andeanFront')
  .controller('ProductdetailController', function ($log, $state, $window, $stateParams, TablesService, $timeout, $scope, $rootScope) {
    var vm = this;
    var owlAPi;
    console.log('ProductdetailController');
    vm.filters = {
      per_page: 100,
      page: 1,
    };
    //$state.go('.', {parm1: 1}, {notify: false});
    vm.selected = {};
    vm.selected.catalias = $stateParams.id;
    vm.selected.id = $stateParams.id2;
    vm.changeCat = function (value) {
      //$state.go('product', {id: value});
      vm.loadCategories();
    };
    vm.changeProd = function (value, index) {
      console.log('cambia producto', value);
      vm.selected.id = value.alias;
      vm.selected.prod = value.nombre;
      vm.itemIndex = index;
      //$state.go('product2', {id: vm.selected.catalias, id2:value.alias}, {notify: false});
    };
    vm.loadCategories = function () {
      TablesService.filtrar('productoscategorias', vm.filters)
        .success(function (res) {
          if (res.resultado) {
            vm.productscat = res.resultado.data;
            for (var i = 0; i < vm.productscat.length; i++) {
              if (vm.selected.catalias == vm.productscat[i].alias) {
                vm.selected.cat = vm.productscat[i].id;
              }
            }
            vm.filters2 = {
              per_page: 1000,
              page: 1,
              comparaciones: [
                {
                  campo: 'productoscategorias_id',
                  operador: 'igual',
                  dato: vm.selected.cat,
                  dato2: ''
                }
              ]
            };
            console.log(vm.selected, vm.productscat)
            vm.loadProducts(vm.filters2);
          }
        });
    };
    vm.print = function (value) {
      console.log("XXXXXXXXXXX", value);
      vm.changeProd(item);
    };
    vm.loadCategories();
    vm.loadProducts = function (filters) {
      TablesService.filtrar('productos', filters)
        .success(function (res) {
          console.log(res)
          if (res.resultado) {
            vm.products = res.resultado.data;
            console.log('productos', vm.selected.id, vm.products);

            //vm.changeProd(vm.products[0]);
            // vm.selected.id = vm.products[0].alias;
            // vm.selected.prod = vm.products[0].nombre;
            //$state.go('product2', {id: vm.selected.catalias, id2:vm.selected.id }, {notify: false});
            //console.log('id cargado', vm.selected.id);
            vm.itemIndex = 0;
            vm.properties = {
              items: 1,
              nav: true,
              startPosition: vm.itemIndex,
              onChange: function (e) {
                //console.log('//////////////////////////////')
                /*console.log("current: ", e.relatedTarget.current())
                console.log("current: ", e.item.index) //same
                console.log("total: ", e.item.count)   //total
                console.log('ejecuta cambio', e.item.index)*/
                console.log('element   ', e.target)       // DOM element, in this example .owl-carousel
                console.log('name      ', e.type)         // Name of the event, in this example dragged
                console.log('namespace ', e.namespace)      // Namespace of the event, in this example owl.carousel
                console.log('items     ', e.item.count)     // Number of items
                console.log('item      ', e.item.index)     // Position of the current item
                //console.log('vided by t',vigation plugin)
                console.log('pages     ', e.page.count)     // Number of pages
                console.log('page      ', e.page.index)     // Position of the current page
                console.log('size      ', e.page.size)
                console.log('size      ', e.itemElement)

                if (e.item.index != 0) {
                  //console.log('ingresa en restriccion', e.item.index);
                  //vm.selected.id = vm.products[e.item.index-2].id;
                  //vm.getId(e.item.index-2);
                  ///////////aca falta///////////////
                  //var item = vm.getItem(e.item.index);
                  //console.log('obtenido para cambio', item, e.item.index)
                  //vm.changeProd(item);
                }
              },
              // loop:true,
              navText: ['<span class="glyphicon glyphicon-menu-left" ></span>', '<span class="glyphicon glyphicon-menu-right" ></span>'],
            };
            $scope.ready = function ($api) {
              owlAPi = $api;
            };
            console.log('por defecto', vm.products[0]);
            //vm.changeProd(vm.products[0]);
            vm.selected.id = vm.products[0].alias;
            vm.selected.prod = vm.products[0].nombre;
            $state.go('product2', {id: vm.selected.catalias, id2: vm.selected.id}, {notify: false});

            console.log('por defecto');
            /*$timeout(function () {
              if(vm.selected.id){
                console.log('precargado');
                var current = vm.getItemByAlias(vm.selected.id);
                console.log('obtenido',current);
                vm.selected.id = current.alias;
                vm.selected.prod = current.nombre;
                console.log('nuevos seteados', vm.selected);
                var cindex = vm.getIndex(current.id);
                console.log('index extraido',cindex);
                //vm.changeProd(current);
                vm.changeSlide(current.id);
              }
              else{
                console.log('por defecto', vm.products[0]);
                //vm.changeProd(vm.products[0]);
                vm.selected.id = vm.products[0].alias;
                vm.selected.prod = vm.products[0].nombre;
                $state.go('product2', {id: vm.selected.catalias, id2:vm.selected.id }, {notify: false});
              }

            }, 2000)*/
          }
        });
    };

    vm.getIndex = function (value) {
      for (var i = 0; i < vm.products.length; i++) {
        if (value === vm.products[i].id) {
          return i;
        }
      }
    };
    vm.getItem = function (value) {
      for (var i = 0; i < vm.products.length; i++) {
        if (value === i) {
          return vm.products[i];
        }
      }
    };
    vm.getItemByAlias = function (value) {
      vm.temp = {};
      for (var i = 0; i < vm.products.length; i++) {
        // console.log('no match')
        if (value == vm.products[i].alias) {
          vm.temp = angular.copy(vm.products[i]);
        }
      }
      console.log('match', vm.temp);
      //vm.changeProd(vm.temp);
      return vm.temp;
    };

    vm.isFirst = function (value) {
      if (vm.products[0].id == vm.selected.id) {
        return true;
      }
      else {
        return false;
      }
    };
    vm.changeSlide = function (value) {
      console.log('cambia', value);
      owlAPi.trigger('to.owl.carousel', [value, 2000]);
    };


  });

'use strict';
angular
  .module('andeanFront')
  .controller('ProductController', function ($log, $state, $window, $stateParams, TablesService, $timeout, $scope, $rootScope) {
    var vm = this;
    console.log('ProductController');
    vm.filters = {
      per_page: 100,
      page: 1
    };
    TablesService.filtrar('productoscategorias', vm.filters)
      .success(function (res) {
        if (res.resultado) {
          vm.productoscategorias = res.resultado.data;
          vm.items = vm.productoscategorias;
          console.log(vm.productoscategorias)
        }
      });
    vm.properties = {
      items: 4,
      nav: true,
      navText: ['<span class="glyphicon glyphicon-menu-left" ></span>', '<span class="glyphicon glyphicon-menu-right" ></span>'],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true,
          loop: true
        },
        767: {
          items: 2,
          nav: true,
          loop: true
        },
        992: {
          items: 4,
          nav: true,
          loop: true
        }
      },
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true
    };


  });

'use strict';
angular
  .module('andeanFront')
  .controller('InicioController', function ($log, TablesService, $timeout) {
    var vm = this;
    $log.debug('InicioController');
    vm.iniciarVideo = function () {
      $log.debug('Iniciando video');
      $('.video-rep')[0].play();
      $timeout(function () {
        vm.mostrarBoton = true;
      }, 300);
    };
  });

'use strict';
angular
  .module('andeanFront')
  .controller('ContactController', function ($log, $rootScope, $state, $stateParams, $timeout, $window, TablesService) {
    var vm = this;
    $log.debug('ContactController');
    //CAPTCHA

    vm.screenWidth = $window.innerWidth;
    $log.debug('screenWidth', vm.screenWidth);

    vm.gencaptcha = function () {
      angular.element(document).ready(function () {
        jQuery.ajax({
          url: 'https://www.google.com/recaptcha/api.js?hl=es',
          dataType: 'script',
          async: true,
          deferer: true
        });
      });
    };

    $rootScope.accordion = [
      false, false, false, false, false, false
    ];

    //Combo business
    vm.catSelect = function (b) {
      vm.businessSel = b;
    };
    vm.catBusiness = [
      {
        id: 1,
        nombre: 'Wholesaler'
      }, {
        id: 2,
        nombre: 'Retailer'
      }, {
        id: 3,
        nombre: 'Detailed Chain'
      }, {
        id: 4,
        nombre: 'Supermarket'
      }, {
        id: 5,
        nombre: 'Hypermarket'
      }, {
        id: 6,
        nombre: 'Department Store'
      }, {
        id: 7,
        nombre: 'Broker'
      }
    ];
    vm.categories = [
      {id: 1, name: "Production and Processing Facilities"},
      {id: 2, name: "Own Offices"},
      {id: 3, name: "Trading"},
      {id: 4, name: "We take our products to"}
    ];

    vm.countriesAll = [
      {iso: "BOL", name: "Bolivia", category: "1"},//
      {iso: "PER", name: "Perú", category: "2"},//
      {iso: "COL", name: "Colombia", category: "2"},//3
      {iso: "CRI", name: "Costa Rica", category: "2"},//
      {iso: "CHL", name: "Chile", category: "3"},//
      {iso: "MYS", name: "Malasia", category: "3"},//6
      {iso: "TWN", name: "Taiwan", category: "3"},//
      {iso: "HKG", name: "Hong Kong", category: "3"},//NO
      {iso: "AUS", name: "Australia", category: "3"},//9
      {iso: "RUS", name: "Russia", category: "3"},//
      {iso: "ARE", name: "United Arab Emirates", category: "4"},//
      {iso: "FRA", name: "France", category: "4"},//12
      {iso: "GBR", name: "England", category: "4"},//
      {iso: "SGP", name: "Singapore", category: "4"},//NO
      {iso: "CAN", name: "Canada", category: "4"},//15
      {iso: "DNK", name: "Denmark", category: "4"},//
      {iso: "ARG", name: "Argentina", category: "4"},//
      {iso: "BRA", name: "Brazil", category: "4"}, //18
      {iso: "ESP", name: "Spain", category: "4"}, //
      {iso: "DEU", name: "Germany", category: "4"},//
      {iso: "ISR", name: "Israel", category: "4"}//21
    ];

    $rootScope.findCountryByIso = function (iso) {
      return vm.countriesAll.filter(function (country) {
        return country.iso === iso;
      });
    };

    $rootScope.findCategories = function (cid) {
      return vm.categories.filter(function (country) {
        return parseInt(country.id) === parseInt(cid);
      });
    };

    $rootScope.colors = function (cid) {
      switch (cid) {
        case "1":
          return '#B43D32';
        case "2":
          return '#E8443A';
        case "3":
          return '#F18952';
        case "4":
          return '#FAB84E';
      }
    };

    if ($state.current.name == 'about') {
      TablesService.filtrar('sliderabout', {per_page: 999, lan: 'en'})
        .success(function (res) {
          if (res.respuesta == true) {
            vm.sliders = res.resultado.data;
          }

          //console.log(res);
        });
    }


    vm.generarSeguridad = function () {
      vm.company = '';
      vm.businessSel = null;
      vm.name = '';
      vm.country = '';
      vm.city = '';
      vm.phone = '';
      vm.email = '';
      vm.subject = '';
      vm.message = '';
      grecaptcha.reset();
    };
    vm.enviarContacto = function () {
      vm.enviando = true;
      if (!vm.company) {
        vm.company = '';
      }
      if (!vm.businessSel) {
        vm.businessSel = {nombre: ''};
      }
      if (!vm.phone) {
        vm.phone = '';
      }
      var datosenviar = {
        empresa: vm.company,
        sector: vm.businessSel.nombre,
        nombre: vm.name,
        cargo: '',
        pais: vm.country,
        ciudad: vm.city,
        telefono: vm.phone,
        email: vm.email,
        motivo: vm.subject,
        mensaje: vm.message,
        gc: jQuery('#g-recaptcha-response').val()
      };


      TablesService.contactar(datosenviar)
        .then(function (res) {
          $log.debug(res);
          vm.enviando = false;
          if (res.data.respuesta) {
            vm.msjtrue = true;
            vm.mensajeForm = 'Thank you! Your message is travelling all the way to Bolivia, we will contact you soon!';
            vm.generarSeguridad();
            $timeout(function () {
              vm.msjtrue = false;
              vm.mensajeForm = '';
            }, 4000);
          } else {
            vm.generarSeguridad();
          }
        })
        .catch(function (response) {
          vm.enviando = false;
          switch (response.data.error) {
            case 'is_robot':
              $log.debug('Intento de conexión forzado.');
              vm.mensajeForm = 'Attempt of forced connection';
              break;
            case 'not_security_validation':
              $log.debug('Verifique que no es un robot.');
              vm.mensajeForm = 'Verify that it is not a robot';
              break;
            default :
              vm.mensajeForm = 'Error sending try again please';
          }
          vm.generarSeguridad();
        });
    };

    /*var mensaje = {
      empresa: 'empresa',
      sector: 'sector',
      nombre: 'nombre',
      cargo: 'cargo',
      pais: 'pais',
      ciudad: 'ciudad',
      telefono: 'telefono',
      email: 'email',
      motivo: 'motivo',
      mensaje: 'mensaje'
    };
    TablesService.contactar(mensaje).success(function (res) {
      console.log(res);
    });*/

  });


'use strict';
angular
  .module('andeanFront')
  .controller('AppController', function ($log, TablesService) {
    var vm = this;
    $log.debug('AppController');

    vm.press_lang = 'en';
    vm.press_list = {
      en: [
        {
          filename: "AVC Brand launching Press release (PDF)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/english/AVC_Brand_launching_Press_release.pdf'
        },
        {
          filename: "AVC Brand launching Press release Interview (PDF)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/english/AVC_Brand_launching_Press_release_interview.pdf'
        },
        {
          filename: "AVC IDs (PDF)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/english/AVC_IDs.pdf'
        },
        {
          filename: "AVC ID Negative version (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/english/AVC_ID_Negative_version.jpg'
        },
        {
          filename: "AVC ID Positive version (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/english/AVC_ID_Positive_version.jpg'
        },
        {
          filename: "AVC Poster ENG (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/english/AVC_Poster_ENG.jpg'
        },
        {
          filename: "AVC Products range (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/english/AVC_Products_range.jpg'
        },
        {
          filename: "Tunupa volcano Salar de Uyuni (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/english/Tunupa_volcano_Salar_de_Uyuni.jpg'
        }
      ],
      es: [
        {
          filename: "AVC Lanzamiento de Marca_Nota de Prensa (PDF)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/spanish/AVC_Lanzamiento_de_Marca_Nota_de_Prensa.pdf'
        },
        {
          filename: "AVC Lanzamiento de Marca_Nota de Prensa_Entrevista (PDF)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/spanish/AVC_Lanzamiento_de_Marca_Nota_de_Prensa_Entrevista.pdf'
        },
        {
          filename: "AVC IDs (PDF)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/spanish/AVC_IDs.pdf'
        },
        {
          filename: "AVC ID Version negativa (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/spanish/AVC_ID_Version_negativa.jpg'
        },
        {
          filename: "AVC ID Version positiva (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/spanish/AVC_ID_Version_positiva.jpg'
        },
        {
          filename: "AVC Poster ESP (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/spanish/AVC_Poster_ESP.jpg'
        },
        {
          filename: "AVC Range de productos (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/spanish/AVC_Range_de_productos.jpg'
        },
        {
          filename: "Volcán Tunupa Salar de Uyuni (JPG)",
          date: '14-feb-2018',
          url: 'http://presskit.andeanvalley.com/spanish/Volcan_Tunupa_Salar_de_Uyuni.jpg'
        },
      ]
    };
  })
  .controller('CertificationsController', function ($log, TablesService) {
    var vm = this;
    $log.debug('CertificationsController');

    var params = {
      page: 1,
      per_page: 999,
      orden: [
        {campo: 'orden', direccion: 'asc'}
      ]
    };
    TablesService.filtrar('certificaciones', params).success(function (res) {
      $log.debug('Certifications: ', res);
      vm.certifications = res.resultado.data;
    });
    /*TablesService.listar('certificaciones').success(function (res) {
      $log.debug('Certifications: ', res);
      vm.certifications = res.resultado;
    });*/

  });

(function() {
  'use strict';

  angular
      .module('andeanFront')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('andeanFront')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('andeanFront')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('andeanFront')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('andeanFront')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('andeanFront')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, localStorageService, $timeout, $window) {
    $rootScope.api = 'http://avcapi.andeanvalley.com';

    $rootScope.language = 'en';

    $rootScope.obtenerVarSession = function (key) {
      return localStorageService.get(key);
    };
    $rootScope.asignarVarSession = function (key, val) {
      return localStorageService.set(key, val);
    };

    /*var loadLang = function(){
      $state.current = toState;
      $rootScope.$state = $state;
      var x = $rootScope.obtenerVarSession('language');
      (x) ? $rootScope.language = x : $rootScope.language = 'en';
    };*/

    $rootScope.changeLanguage = function (value, state) {
      $rootScope.language = value;
      $rootScope.asignarVarSession('language', value);
      $state.go(state, {lan: value});
    };

    var stateActual = function () {
      $rootScope.actualstate = $state.current.name;
      $log.debug($rootScope.actualstate);
    };
    stateActual();
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      $('html, body').animate({scrollTop: 0}, 'fast');
      /*$timeout(function () {
        var evt = $window.document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, $window, 0);
        $window.dispatchEvent(evt);
      }, 10);*/
      stateActual();
    });

    $log.debug('intenet explerer navigator', window.navigator.userAgent);
    if (navigator.userAgent.indexOf("MSIE") != -1) {
      $log.debug('intenet explerer navigator', window.navigator.userAgent);
    }

    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular
    .module('andeanFront')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/views/home.html',
        controller: 'InicioController',
        controllerAs: 'ini'
      })
      .state('about', {
        url: '/about-us',
        templateUrl: 'app/views/about.html',
        controller: 'ContactController',
        controllerAs: 'c'
      })
      .state('suppliers', {
        url: '/suppliers-program',
        templateUrl: 'app/views/suppliers.html'
      })
      .state('traceability', {
        url: '/suppliers-program/traceability',
        templateUrl: 'app/views/traceability.html',
        controller: 'TraceabilityController',
        controllerAs: 'trc'
      })
      .state('products', {
        url: '/products',
        templateUrl: 'app/views/products/products.html',
        controller: 'ProductController',
        controllerAs: 'prod'
      })
      .state('product', {
        url: '/products/:id',
        templateUrl: 'app/views/products/detalle.html',
        controller: 'ProductdetailController',
        controllerAs: 'prod2'
      })
      .state('product2', {
        url: '/products/:id/:id2',
        templateUrl: 'app/views/products/detalle.html',
        controller: 'ProductdetailController',
        controllerAs: 'prod2'
      })
      .state('quinoa', {
        url: '/royal-quinoa',
        templateUrl: 'app/views/products/quinoa.html'
      })
      .state('certifications', {
        url: '/certifications',
        templateUrl: 'app/views/certifications.html',
        controller: 'CertificationsController',
        controllerAs: 'crt'
      })
      .state('contact', {
        url: '/contact',
        templateUrl: 'app/views/contact.html',
        controller: 'ContactController',
        controllerAs: 'ct'
      })
      .state('presskit', {
        url: '/press-kit',
        templateUrl: 'app/views/press-list.html'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function () {
  'use strict';

  angular
    .module('andeanFront')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function () {
  'use strict';

  angular
    .module('andeanFront')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("andeanFront").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/views/about.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"pagina about\"><carousel class=\"slider-about\" active=\"active\" interval=\"3000\" no-wrap=\"\"><slide uib-slide=\"\" ng-repeat=\"slide in c.sliders\"><div class=\"cuadro-banner\"><div><p>{{slide.texto}}</p></div></div><img src=\"{{slide.imagen}}\" alt=\"{{slide.texto}}\" title=\"{{slide.title}}\"></slide></carousel><div class=\"avc-info row\"><div class=\"container\"><div class=\'row\"\'><div class=\"content col-xs-12 col-sm-12 col-md-12\"><p>Our company grows, our brand re-evolves and our products expand into the world. We are stronger than ever, ready to leap into a new transformative future. We want to share our knowledge and energy to empower and nourish the world, while remaining –as always– steadfast protectors of our ancestral legacy, our people and our soil.</p></div></div></div></div><div class=\"avc-us\"><div class=\"container\"><div class=\"elem-animate\"><svg width=\"413px\" height=\"172px\" viewbox=\"0 0 413 172\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><clippath id=\"clip-path\" transform=\"translate(316 -5)\"><rect class=\"cls-1\" width=\"318\" height=\"180\"></rect></clippath><title>lineas_about_us</title><g class=\"cls-2\"><path class=\"about-l1\" d=\"M296,133.22,210.73,47.93a79.3,79.3,0,0,0-112.15,0L13.29,133.22a79.32,79.32,0,0,1-112.15,0l-85.29-85.29a79.3,79.3,0,0,0-112.15,0\" transform=\"translate(0 -5)\"></path><path class=\"about-l2\" d=\"M295.58,133.22a79.32,79.32,0,0,1-112.15,0L98.14,47.93A79.3,79.3,0,0,0-14,47.93L-99.3,133.22\" transform=\"translate(0 -5)\"></path></g></svg></div><div class=\"row\"><div class=\"phrase\"><h2>The Re-evolution of a<br>holistic nutrition worldwide</h2></div><div class=\"elem-bottom col-xs-12 col-sm-4 col-md-3\"><div data-in-view=\"ini.trazoquinoa = $inview\" data-ng-class=\"{ dibujar: ini.trazoquinoa }\" class=\"dibujar\" style=\"\"></div><div class=\"quinuas row\"><img class=\"img-responsive\" src=\"../../assets/images/icons/icon-quinoa-red.png\"> <img class=\"img-responsive\" src=\"../../assets/images/icons/icon-quinoa-red.png\"> <img class=\"img-responsive\" src=\"../../assets/images/icons/icon-quinoa-red.png\"></div></div></div><div class=\"row\"><div class=\"text-experience col-xs-12 col-sm-12 col-md-12\"><div class=\"row\"><h3 class=\"titulo-bloque amarillo\">The Quinoa world</h3><p>We have the largest quinoa processing capacity of Bolivia and the world, and we have expanded our reach across borders, opening our own sales companies and distributors, Brazil, Colombia, Costa Rica, Perú and Japan. using state-of-the-art technology in our facilities to create super healthy, nutritious and tasty products, we share our Andean Tradition with more than 15 countries around the world.</p><div class=\"mapd3\" ng-if=\"c.screenWidth>758\"><svg><g id=\"marco_mapa\" transform=\"translate(2.000000, 16.000000) scale(.97)\" stroke=\"#73C364\" stroke-width=\"4\" fill=\"white\"><path d=\"M40.7146728,632.707697 C40.7146728,637.439032 36.8674225,641.273254 32.1416664,641.273254 L0.403972502,641.273254 L0.403972502,609.565558 C0.403972502,604.834222 4.25122273,601 8.97819065,601 L40.7146728,601 L40.7146728,632.707697 Z\" id=\"Stroke-3\"></path><path d=\"M1049,33.5079773 C1049,38.5068731 1044.93585,42.5602281 1039.93988,42.5602281 L1006.40397,42.5602281 L1006.40397,9.05225083 C1006.40397,4.05214438 1010.46812,-3.55271368e-15 1015.46288,-3.55271368e-15 L1049,-3.55271368e-15 L1049,33.5079773 Z\" id=\"Stroke-1\"></path><path d=\"M1006.77264,573.638416 C1006.77264,588.639946 994.600792,600.802432 979.587428,600.802432 L40.4039725,600.802432 L40.4039725,70.1640166 C40.4039725,55.1624865 52.575824,43 67.5891879,43 L1006.77264,43 L1006.77264,573.638416 Z\" id=\"Stroke-5\"></path></g></svg><div class=\"speech-bubble\"><p class=\"country\"></p><p class=\"category\"></p></div></div><div class=\"\" ng-if=\"c.screenWidth<=758\"><img class=\"img-responsive\" src=\"../../assets/images/mapa_movil.png\"></div><div class=\"countries-info\"><h4>Our global brand expansion</h4><div class=\"col-xs-12 col-sm-4 col-md-4\"><h5>Headquarters</h5><p>Bolivia</p><h5>Production and Processing Facilities</h5><p>Bolivia</p><p>Peru (own offices)</p></div><div class=\"col-xs-12 col-sm-4 col-md-4\"><h5>Trading</h5><p>Colombia (own offices)</p><p>Costa Rica (own offices)</p><p>Chile</p><p>Malasia</p><p>Taiwan</p><p>Hong Kong</p><p>Australia</p><p>Russia</p></div><div class=\"col-xs-12 col-sm-4 col-md-4\"><h5>We take our products to</h5><p>United Arab Emirates</p><p>France</p><p>England</p><p>USA (Miami & Los Angeles)</p><p>Singapore</p><p>Canada</p><p>Denmark</p><p>Argentina</p><p>Brazil</p><p>Spain</p><p>Germany</p><p>Israel</p></div></div></div></div><div class=\"text-experience col-xs-12 col-sm-12 col-md-12\"><div class=\"row\"><p>Drawing our expertise and determination from our 20 years experience producing, processing and exporting this amazing andean grain.</p></div></div></div><div class=\"accordion row\"><accordion close-others=\"oneAtATime\"><accordion-group heading=\"We lead and create\" is-open=\"false\"><p>From our very beginning as a company that just processed Royal Quinoa, we have always pushed our boundaries and kept innovation as our goal. We have walked this path with a strong sense of commitment and courage, and today we proudly offer our clients and consumers a wonderful range of 50 organic, gluten-free, non- GMO, no-coloring and no-preservatives products. Standing firm and tall, we share a tradition that carries the promise of healthier, more nutritious food to more than 20 countries around the world</p></accordion-group><accordion-group heading=\"We are organic 3.0\" is-open=\"false\"><p>Andean Valley has been certified organic, since, 1998. Making it the oldest company in Latin America to have this certification. Our certifications endorse that we keep up with the strictest global requirements on quality standards: FSSC22000, NOPUSDA, THE EU, CAN, FDA, KOSHER, HAACP, GMP.</p><p>We work with the a holistic vision and truly believe that the success of the company is engrained in the success of our providers, the heart that our employees and partners put into our products and actions and more so in the profound desire to bring to you a product that nourishes your soul.</p></accordion-group><accordion-group heading=\"Technologic development\" is-open=\"false\"><p>Our visión of technological development leads us to actively support as well as we work with the main research centers and chambers -such as CPTS, CABOLQUI and PROINPA- in the most essential aspects of our corporative philosophy: sustainability, genuine organic quality, welfare of farmers and transparency in traceability.</p></accordion-group><accordion-group heading=\"Around the world\" is-open=\"false\"><p>We dared to tell the world that there is one better feeding. And for this reason, we\'ve reached to produce 700 METRIC TON per month of high dense quinoa grains. We always have the challenge to offer you more!</p><p>We are present in five continents and nineteen countries. Yes, we have committed ourselves to challenging the industry and going beyond the evolution of real nourishment. Our spirit is anchored to the holistic nutrition.</p><p>Along with more than ten global strategic allies that represent us, we will continue our expansion in the construction of better alternatives for welfare, quality of life and sustainable nutrition over the world. Bringing you more than fifty holistic nutritious products.</p></accordion-group><accordion-group heading=\"Quinoa re-evolution\" is-open=\"false\"><p>We encourage a positive awareness that has made us work hand in hand over 21 years in order to achieve a better well-being in 18 communities with which we have a solid and unique relationship in the Southern Bolivian highlands.</p><p>Committing ourselves into protecting the Earth has made us build grand learning spaces along with our dedicated producers, whom we constantly train in organic sustainable production techniques.</p><p>Over 4000 hectares are impacted by this captivating, positive and transforming energy which causes the well-being for future generations to be cultivated in our farmers’ fields.</p><p>Protection begins at home. Accordingly, our corporation will firmly continue supporting all State policy that prompts the protection and development of our people, always prioritizing all aim that places healthy diet as a progress core.</p></accordion-group></accordion></div></div></div></div>");
$templateCache.put("app/views/certifications.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"pagina certifications\" data-ng-class=\"{fondoimg: crt.hoveractive}\"><div class=\"fondo\"></div><div class=\"cont-col\"><div class=\"col\"><h3 class=\"titulo-banner amarillo\">CERTIFICATIONS</h3></div></div><div class=\"cont-cert\"><div class=\"certification\" data-ng-repeat=\"c in crt.certifications\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"info\" data-ng-if=\"c.texto\"><div class=\"center\"><p data-ng-bind-html=\"c.texto\"></p><img src=\"../assets/images/icons/subrayado_frases.png\" alt=\"\"></div></div><img src=\"\" alt=\"\" data-ng-src=\"{{c.imagen}}\" data-ng-if=\"c.imagen\"><p data-ng-if=\"!c.imagen\">FDA – U.S. Food & Drug Administration,</p></div></div></div><div class=\"cont-col\"><div class=\"col\"><h3 class=\"titulo-banner amarillo\">VALUES</h3></div></div><div class=\"cont-cuadro\"><div class=\"cuadro\"><p>From the beginning as a company, we have believed that the values and commitments that we consolidate would lead us to create a “quinoa world” where our employees, farmers and clients are certain that they work with a company that has a holistic management vision.</p><p>Our amazing range of 50 organic, gluten-free, non- GMO, no-coloring and no-preservatives products, our 483 farmer families and our clients across 20 countries can count on products that follow values and standards that generate holistic well-being.</p></div></div><div class=\"cont-cert values\"><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><img src=\"../assets/images/logo_home.png\" alt=\"\"><p>Suppliers program.</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><p>Sustainable Quinoa – Green Quinoa.</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><p>Humane Quinoa</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><p>Farmes Welfare</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><p>Practice Fair trade (Non - certified)</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><img src=\"../assets/images/icons/Gluten-free.png\" alt=\"\"><p>Gluten free</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><img src=\"../assets/images/icons/vegan-vegetarian.png\" alt=\"\"><p>Vegan/Vegetarian</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><img src=\"../assets/images/icons/non-gmo.png\" alt=\"\"><p>Non - GMO</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><p>Whole Grain</p></div></div></div><div class=\"certification\"><div class=\"borde\" data-proporcion=\"{\'ancho\':1, \'alto\':1}\"><div class=\"center\"><img src=\"../assets/images/icons/bpa-Free.png\" alt=\"\"><p>BPA free</p></div></div></div></div></div>");
$templateCache.put("app/views/contact.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"pagina contact\"><div class=\"container\"><h4>Are you interested in being part of this re-evolution?</h4><h2>WE’D LOVE TO TALK</h2><form data-ng-submit=\"ct.enviarContacto();\"><div class=\"cont-cols\"><div class=\"col\"><div class=\"cont-input\"><div class=\"icon\"><img src=\"../assets/images/icons/company.png\" alt=\"\"></div><input type=\"text\" data-ng-model=\"ct.company\" data-ng-class=\"{lleno: ct.company}\" placeholder=\"What is your company\'s name?\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\"></div></div><div class=\"col\"><div class=\"cont-input\"><div class=\"icon\"></div><div class=\"ind-drop-down\" data-opciones=\"ct.catBusiness\" data-txdefault=\"What sector of the business are you in?\" data-campotx=\"nombre\" data-onselect=\"ct.catSelect(ct.businessSel);\" data-opselected=\"ct.businessSel\"></div></div></div></div><div class=\"cont-input\"><div class=\"icon\"><img src=\"../assets/images/icons/contact_person.png\" alt=\"\"></div><input type=\"text\" data-ng-model=\"ct.name\" data-ng-class=\"{lleno: ct.name}\" placeholder=\"*What is your name?\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\"></div><div class=\"cont-cols\"><div class=\"col\"><div class=\"cont-input\"><div class=\"icon\"><img src=\"../assets/images/icons/country.png\" alt=\"\"></div><input type=\"text\" data-ng-model=\"ct.country\" data-ng-class=\"{lleno: ct.country}\" placeholder=\"*What beautiful country are you from?\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\"></div></div><div class=\"col\"><div class=\"cont-input\"><div class=\"icon\"><img src=\"../assets/images/icons/city.png\" alt=\"\"></div><input type=\"text\" data-ng-model=\"ct.city\" data-ng-class=\"{lleno: ct.city}\" placeholder=\"*What amazing city do you live in?\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\"></div></div></div><div class=\"cont-cols\"><div class=\"col\"><div class=\"cont-input\"><div class=\"icon\"><img src=\"../assets/images/icons/phone.png\" alt=\"\"></div><input type=\"text\" data-ng-model=\"ct.phone\" data-ng-class=\"{lleno: ct.phone}\" placeholder=\"If we need to call you what is your phone number?\" data-ng-pattern=\"/^[+0-9].{5,20}$/\"></div></div><div class=\"col\"><div class=\"cont-input\"><div class=\"icon\"><img src=\"../assets/images/icons/email.png\" alt=\"\"></div><input type=\"text\" placeholder=\"*Email is a great way to contact you.\" data-ng-model=\"ct.email\" data-ng-class=\"{lleno: ct.email}\" data-ng-pattern=\'/^(([^<>()[\\]\\\\.,;:\\s@\\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\\"]+)*)|(\\\".+\\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\'></div></div></div><div class=\"cont-input\"><div class=\"icon\"><img src=\"../assets/images/icons/subject.png\" alt=\"\"></div><input type=\"text\" data-ng-model=\"ct.subject\" data-ng-class=\"{lleno: ct.subject}\" placeholder=\"*What is your inquiry about?\" data-ng-pattern=\"/^[a-zA-Zñáéíóú0-9\\s]*.{3}$/\"></div><div class=\"cont-input\"><div class=\"icon\"><img src=\"../assets/images/icons/message.png\" alt=\"\"></div><textarea type=\"text\" data-ng-model=\"ct.message\" data-ng-class=\"{lleno: ct.message}\" placeholder=\"*Leaves us a message so we can get back you soon.\" data-ng-pattern=\"/^[a-zA-Zñáéíóú0-9\\s]*.{3}$/\"></textarea></div><p data-ng-if=\"ct.enviando\">Enviando...</p><p data-ng-if=\"ct.mensajeForm\" data-ng-bind=\"ct.mensajeForm\" data-ng-class=\"{verde: ct.msjtrue}\">Your message has been sent, we will contact you soon!</p><div class=\"cont-submit\"><div class=\"cont-recaptcha\" data-ng-init=\"ct.gencaptcha();\"><div class=\"g-recaptcha\" data-sitekey=\"6Lek60UUAAAAACnvpRqsr2lsOXWCPTG8vpCD4bBh\"></div></div><div class=\"cont-bt\"><input type=\"submit\" value=\"SEND\" class=\"bt-nav amarillo\"></div></div></form></div><div class=\"cont-cols\"><div class=\"col\"><h2 class=\"titulo-banner\">Were we are in Bolivia</h2><p>Andean Valley Corporation Headquarters<br>Av. Panamericana #1959<br>Rio Seco - El Alto<br>Bolivia<br>Our phone numbers: +591-2-2863058 / 2862853<br>Contact e-email: info@andeanvalley.com</p></div><div class=\"col\"><ng-map center=\"-16.488201, -68.215448\" zoom=\"16\"><marker position=\"-16.488201, -68.215448\" title=\"Andean Valley Corporation\" icon=\"../assets/images/icons/marker_avc.png\"></marker></ng-map></div></div></div>");
$templateCache.put("app/views/footer.html","<div class=\"footer\"><div class=\"sello\"><p>© 2018 Andean Valley Corporation</p></div><div class=\"info\"><p>info@andeanvalley.com</p></div><div class=\"sociales\"><ul><li><a class=\"rrss\" target=\"_blank\" href=\"https://www.facebook.com/andeanvalley/\"><i class=\"fab fa-facebook-f\"></i></a></li><li><a class=\"rrss\" target=\"_blank\" href=\"https://www.instagram.com/andeanvalley.bo/\"><i class=\"fab fa-instagram\"></i></a></li><li><a class=\"rrss\" target=\"_blank\" href=\"https://www.linkedin.com/company/3053191/\"><i class=\"fab fa-linkedin-in\"></i></a></li><li><a class=\"rrss\" target=\"_blank\" href=\"https://www.youtube.com/channel/UCY7aI_tcNI9hMWPjVezsV6Q?view_as=subscriber\"><i class=\"fab fa-youtube\"></i></a></li></ul></div></div>");
$templateCache.put("app/views/header.html","<nav class=\"header\"><div class=\"logo\"><a href=\"/\"><img src=\"../assets/images/logo_home.png\" alt=\"\"></a></div><div class=\"bt-menu\"><div class=\"menu\" data-ng-class=\"{active: ini.verMenu}\" data-ng-click=\"ini.verMenu = !ini.verMenu\"><span></span><span></span><span></span></div></div><ul class=\"menu lista-menu\" data-ng-class=\"{menuxs: ini.verMenu}\"><li><a href=\"/about-us\" data-ng-class=\"{active: actualstate==\'about\'}\"><span>ABOUT US</span></a></li><li><a href=\"/suppliers-program\" data-ng-class=\"{active: actualstate==\'suppliers\'}\"><span>SUPPLIERS PROGRAM</span></a></li><li><a href=\"/products\" data-ng-class=\"{active: actualstate==\'products\' || actualstate==\'quinoa\' || actualstate==\'product\'}\"><span>PRODUCTS</span></a></li><li><a href=\"/certifications\" data-ng-class=\"{active: actualstate==\'certifications\'}\"><span>CERTIFICATIONS</span></a></li><li><a href=\"/contact\" data-ng-class=\"{active: actualstate==\'contact\'}\"><span>CONTACT</span></a></li><li><a href=\"/press-kit\" data-ng-class=\"{active: actualstate==\'press-kit\'}\"><span>PRESS KIT</span></a></li></ul></nav>");
$templateCache.put("app/views/home.html","<div class=\"home\"><div class=\"cont-video height100\"><video src=\"../assets/images/180209-AVC-Loop-Web-1.mp4\" class=\"video-fondo\" autoplay=\"\" loop=\"\" muted=\"\" poster=\"../assets/images/video-loop (0-00-00-00).png\" data-ng-class=\"{ocultar: ini.mostrarBoton}\"></video><video src=\"../assets/images/180209-Andean-Valley-Manifiesto-de-Marca-v1.mp4.mp4\" class=\"video-rep\" data-ng-class=\"{mostrat: ini.mostrarBoton}\"></video><div class=\"logo\" data-ng-show=\"!ini.mostrarBoton\"><img src=\"../assets/images/logo_home.png\" alt=\"\"></div><div class=\"icon-scroll\"></div><div class=\"bt-play\" data-ng-click=\"ini.iniciarVideo();\" data-ng-show=\"!ini.mostrarBoton\"><h1>Evolving Quinoa</h1><h1>Nurturing Souls.</h1><img src=\"../assets/images/icons/trazo_abajo_titulo.png\" alt=\"\" class=\"subrayado\"> <img src=\"../assets/images/icons/boton_play.svg\" alt=\"\"></div><div class=\"linea1\" data-in-view=\"ini.linea1 = $inview\" data-ng-class=\"{ dibujar: ini.linea1 }\" data-ng-show=\"!ini.mostrarBoton\"><svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 256.06 47.71\"><defs><style>.cls-1 {\n            fill: none;\n            stroke: #ffb94b;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n            stroke-width: 6px;\n          }</style></defs><title>trazo-03</title><path class=\"cls-1\" d=\"M65.51,10.35l27,27a25.12,25.12,0,0,0,35.51,0\"></path><path class=\"cls-1\" d=\"M3,37.36a25.12,25.12,0,0,0,35.51,0l27-27a25.12,25.12,0,0,1,35.51,0l27,27a25.12,25.12,0,0,0,35.51,0l27-27a25.12,25.12,0,0,1,35.51,0l27,27\"></path></svg></div><div class=\"linea2\" data-in-view=\"ini.linea2 = $inview\" data-ng-class=\"{ dibujar: ini.linea2 }\" data-ng-show=\"!ini.mostrarBoton\"><svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 257.85 43.92\"><defs><style>.cls-1 {\n            fill: none;\n            stroke: #ffb94b;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n            stroke-width: 6px;\n          }</style></defs><title>trazo</title><path class=\"cls-1\" d=\"M3,34.23,27.55,9.68a22.82,22.82,0,0,1,32.27,0L84.37,34.23a22.81,22.81,0,0,0,32.28,0L141.2,9.68a22.82,22.82,0,0,1,32.27,0L198,34.23a22.81,22.81,0,0,0,32.28,0L254.85,9.68\"></path></svg></div><div class=\"linea3\" data-in-view=\"ini.linea3 = $inview\" data-ng-class=\"{ dibujar: ini.linea3 }\" data-ng-show=\"!ini.mostrarBoton\"><svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 339.67 46.99\"><defs><style>.cls-1 {\n            fill: none;\n            stroke: #ffb94b;\n            stroke-linecap: round;\n            stroke-miterlimit: 10;\n            stroke-width: 6px;\n          }</style></defs><title>trazo-02</title><path class=\"cls-1\" d=\"M336.67,36.76,310.13,10.23a24.66,24.66,0,0,0-34.89,0L248.71,36.76a24.67,24.67,0,0,1-34.9,0L187.28,10.23a24.66,24.66,0,0,0-34.89,0L125.85,36.76a24.66,24.66,0,0,1-34.89,0L64.43,10.23a24.67,24.67,0,0,0-34.9,0L3,36.76\"></path><path class=\"cls-1\" d=\"M336.67,36.76a24.66,24.66,0,0,1-34.89,0L275.24,10.23a24.66,24.66,0,0,0-34.89,0L213.81,36.76a24.66,24.66,0,0,1-34.89,0L152.39,10.23a24.66,24.66,0,0,0-34.89,0L91,36.76\"></path></svg></div></div></div><header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\" style=\"position: sticky; top: 0; z-index: 999;\" class=\"home\"></header><div class=\"home\"><div class=\"bloque verde\"><div class=\"col\"><div class=\"center\"><h2 class=\"texto-bloque\">We love Creating<br>the Quinoa World.</h2><a href=\"/about-us\" class=\"bt-nav amarillo\">See how we evolve</a></div></div><div class=\"elem-bottom\"><div><img src=\"../assets/images/icons/icon-quinoa-white.png\" alt=\"\"></div><div><img src=\"../assets/images/icons/icon-quinoa-white.png\" alt=\"\"></div><div data-in-view=\"ini.trazoquinoa = $inview\" data-ng-class=\"{ dibujar: ini.trazoquinoa }\"><svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 103.89 143.31\"><defs><style>.cls-1 {\n              fill: none;\n              stroke-linecap: round;\n              stroke-miterlimit: 10;\n              stroke-width: 6px;\n            }</style></defs><title>quinoa</title><path class=\"cls-1\" d=\"M52,140.31l0-30.45L72.58,89.32s13-14.07,27.07,0L79.3,109.66s-12.49,15-27.29.22l-20.7-20.7s-13-14.07-27.07,0l20.6,20.59s13.23,14,27.19,0l0-24.3c13.77,0,13.27-13.62,13.27-13.62S63.36,3,51.94,3C41.37,3,38.66,57.63,38.32,69.87a18.55,18.55,0,0,0,1.24,7.42,12.49,12.49,0,0,0,12.21,8.25\"></path></svg></div></div><div class=\"elem-animate\"><svg width=\"413px\" height=\"172px\" viewbox=\"0 0 413 172\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>home_cont_verde_vect1</title><desc>Created with Sketch.</desc><defs><rect id=\"path-1\" x=\"0\" y=\"0\" width=\"436\" height=\"232\"></rect></defs><g id=\"ESTRUCTURA\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"01--Home\" transform=\"translate(-1027.000000, -998.000000)\"><g id=\"home_cont_verde_vect1\" transform=\"translate(1004.000000, 956.000000)\"><g id=\"Page-1-Copy-10\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Mask\"></g><g mask=\"url(#mask-2)\" stroke-linecap=\"round\" stroke-width=\"25\" stroke-linejoin=\"round\"><g transform=\"translate(43.000000, 62.000000)\"><path class=\"linearoja\" d=\"M592.323,108.5185 L507.032,23.2275 C476.062,-7.7425 425.851,-7.7425 394.882,23.2275 L309.591,108.5185 C278.622,139.4875 228.41,139.4875 197.44,108.5185 L112.15,23.2275 C81.18,-7.7425 30.969,-7.7425 0,23.2275\" id=\"Stroke-1\" stroke=\"#F54137\"></path><path d=\"M591.883,108.5185 C560.913,139.4875 510.701,139.4875 479.733,108.5185 L394.442,23.2275 C363.472,-7.7425 313.261,-7.7425 282.291,23.2275 L197,108.5185\" id=\"Stroke-3\" stroke=\"#FFB94B\"></path></g></g></g></g></g></g></svg></div></div><div class=\"bloque suppliers-program\"><div class=\"col md5\"><div class=\"center\"><h2 class=\"titulo-bloque verde\">Our Suppliers Program</h2><div class=\"cuadro-info\"><p>From our farms to the fork, and from the fork to your heart.</p><a href=\"/suppliers-program\">Dive in</a></div></div></div><div class=\"col md2\"></div><div class=\"col md5\"><img src=\"../assets/images/suppliers_program.png\" alt=\"\"></div></div><div class=\"bloque amazing-products\"><div class=\"elem-animate\"><svg class=\"lineaplato1\" id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 78.68 78.68\" data-in-view=\"ini.lineaplato = $inview\" data-ng-class=\"{ dibujar: ini.lineaplato }\"><defs><style>.cls-1 {\n            fill: none;\n            stroke: #ffb94b;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n          }</style></defs><title>linea1_plato</title><path class=\"cls-1\" d=\"M1.5,77.18A10.75,10.75,0,0,1,12.25,66.43H28.59A10.74,10.74,0,0,0,39.34,55.69V39.34A10.75,10.75,0,0,1,50.09,28.59H66.43A10.74,10.74,0,0,0,77.18,17.85V1.5\"></path></svg><svg class=\"lineaplato2\" id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 59.26 94.05\" data-in-view=\"ini.lineaplato = $inview\" data-ng-class=\"{ dibujar: ini.lineaplato }\"><defs><style>.cls-1 {\n            fill: none;\n            stroke: #ffb94b;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n          }</style></defs><title>linea2_plato</title><path class=\"cls-1\" d=\"M1.5,92.55a10.75,10.75,0,0,0,8-12.93L5.73,63.71a10.75,10.75,0,0,1,8-12.93L29.63,47a10.75,10.75,0,0,0,8-12.93l-3.76-15.9a10.75,10.75,0,0,1,8-12.93L57.76,1.5\"></path></svg><svg class=\"lineaplato3\" id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 103.24 49.22\" data-in-view=\"ini.lineaplato = $inview\" data-ng-class=\"{ dibujar: ini.lineaplato }\"><defs><style>.cls-1 {\n            fill: none;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n          }</style></defs><title>linea3_plato</title><path class=\"cls-1\" d=\"M101.74,2.47A10.75,10.75,0,0,0,87.5,7.8L80.73,22.67A10.75,10.75,0,0,1,66.5,28L51.62,21.22a10.74,10.74,0,0,0-14.23,5.33L30.61,41.42a10.74,10.74,0,0,1-14.23,5.33L1.5,40\"></path></svg></div><div class=\"elem-animated1\" data-in-view=\"ini.animproductos = $inview\" data-ng-class=\"{ dibujar: ini.animproductos }\"><svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewbox=\"0 0 631.72 171.14\"><defs><style>.clsn-1, .clsn-3 {\n            fill: none;\n          }\n\n          .clsn-2 {\n            clip-path: url(#clip-path);\n          }\n\n          .clsn-3 {\n            stroke: #ffb94b;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n            stroke-width: 39.4px;\n          }</style><clippath id=\"clip-path\"><rect class=\"clsn-1\" x=\"0.26\" y=\"0.19\" width=\"566\" height=\"171\"></rect></clippath></defs><g class=\"clsn-2\"><path class=\"clsn-3\" d=\"M546.52,128.72l-85.29-85.3a79.32,79.32,0,0,0-112.15,0l-85.29,85.3a79.32,79.32,0,0,1-112.15,0L66.35,43.42a79.32,79.32,0,0,0-112.15,0\"></path><path class=\"clsn-3\" d=\"M546.52,128.72a79.32,79.32,0,0,1-112.15,0l-85.29-85.3a79.32,79.32,0,0,0-112.15,0l-85.29,85.3\"></path></g></svg></div><div class=\"col md5\"><h2 class=\"titulo-bloque amarillo\">Amazing Products</h2><div class=\"cuadro-info\"><p>Nourished to re-evolve.</p><a href=\"/products\">Discover them!</a></div></div><div class=\"col md7\"><img src=\"\" alt=\"\"></div></div><div class=\"bloque contact-us\"><h2 class=\"texto-bloque\">Are you Interested in our products?</h2><img src=\"../assets/images/icons/subrayado-verde.png\" alt=\"\" class=\"subrayado\"><div class=\"cont-texto\"><h2>LET´S TALK</h2><a href=\"/contact\">We love hearing from you</a></div><div class=\"elem-animate\" data-in-view=\"ini.dibujarelem = $inview\" data-ng-class=\"{ dibujar: ini.dibujarelem }\"><svg width=\"413px\" height=\"172px\" viewbox=\"0 0 413 172\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>home_cont_verde_vect1</title><desc>Created with Sketch.</desc><defs><rect id=\"path-1\" x=\"0\" y=\"0\" width=\"436\" height=\"232\"></rect></defs><g id=\"ESTRUCTURA\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"01--Home\" transform=\"translate(-1027.000000, -998.000000)\"><g id=\"home_cont_verde_vect1\" transform=\"translate(1004.000000, 956.000000)\"><g id=\"Page-1-Copy-10\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Mask\"></g><g mask=\"url(#mask-2)\" stroke-linecap=\"round\" stroke-width=\"25\" stroke-linejoin=\"round\"><g transform=\"translate(43.000000, 62.000000)\"><path class=\"linearoja\" d=\"M592.323,108.5185 L507.032,23.2275 C476.062,-7.7425 425.851,-7.7425 394.882,23.2275 L309.591,108.5185 C278.622,139.4875 228.41,139.4875 197.44,108.5185 L112.15,23.2275 C81.18,-7.7425 30.969,-7.7425 0,23.2275\" id=\"Stroke-1\" stroke=\"#FFB94B\"></path><path d=\"M591.883,108.5185 C560.913,139.4875 510.701,139.4875 479.733,108.5185 L394.442,23.2275 C363.472,-7.7425 313.261,-7.7425 282.291,23.2275 L197,108.5185\" id=\"Stroke-3\" stroke=\"#FFB94B\"></path></g></g></g></g></g></g></svg></div></div></div>");
$templateCache.put("app/views/press-list.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"pagina contact press-list\"><div class=\"container\"><div class=\"grafica\"></div><h4></h4><h2>PRESS KIT</h2><div class=\"cont-cols\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h3>Select language</h3><div class=\"col-xs-12 col-sm-8 col-md-6 button-wrapper\"><div class=\"button\" ng-click=\"app.press_lang=\'en\'\">English</div><div class=\"button\" ng-click=\"app.press_lang=\'es\'\">Español</div></div></div></div><div class=\"cont-cols\"><table class=\"table table-striped\"><thead><tr><th scope=\"col\">{{((app.press_lang==\'en\')?\'Filename\':\'Archivo\')}}</th><th scope=\"col\">{{((app.press_lang==\'en\')?\'Date\':\'Fecha\')}}</th><th scope=\"col\">{{((app.press_lang==\'en\')?\'Options\':\'Opciones\')}}</th></tr></thead><tbody><tr ng-repeat=\"file in app.press_list[app.press_lang] track by $index\"><td ng-bind=\"file.filename\"></td><td ng-bind=\"file.date\"></td><td><a target=\"_blank\" href=\"{{file.url}}\">{{((app.press_lang==\'en\')?\'Download\':\'Descargar\')}}</a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/views/suppliers.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"pagina suppliers\"><div class=\"banner\"><h2 class=\"titulo-banner rojo\">Ancestral wisdom, progress for the future.</h2><div class=\"bloque-blanco\"><h3>WE BELIEVE IN HOLISTIC EMPOWERMENT.</h3><img src=\"../assets/images/icons/subrayado_frases.png\" alt=\"\"></div></div><div class=\"verde cont-igualar\" data-elementos=\"col\" data-columnas=\"2\" data-reload=\"true\"><div class=\"col\"><img src=\"../assets/images/icons/home_cont_verde_quinoa_amarillo.svg\" alt=\"\"></div><div class=\"col\"><p>Our Suppliers Program is a unique in the Andes project of collaboration with 18 local farming communities of the Bolivian south highlands. We support and assist in techniques to grow and manage Organic Royal Quinoa from the seeding to the post-harvest processes; the provision of Organic supplies and tools secure a good result in the organic crop and a fair trade Price for their products. Our program is a socially responsible way to guarantee the sustainability of our process and the traceability of our organic production. This way, we improve and evolve as a community, and we can all share and enjoy the wonderful legacy of Royal Quinoa!</p></div></div><div class=\"cont-blanco\"><div class=\"cont-cols\"><div class=\"col\"><h3>Discover our path from our farms to the fork.<br>From the fork to your heart.</h3></div><div class=\"col\"><div class=\"center\"><a href=\"/suppliers-program/traceability\" class=\"bt-nav amarillo\">Find Out</a> <img src=\"../assets/images/icons/subrayado-verde.png\" alt=\"\"></div></div></div><div class=\"cont-datos cont-igualar\" data-elementos=\"col\" data-columnas=\"2\" data-maxheight=\"true\"><div class=\"col\"><ul class=\"datos\" data-in-view=\"contadores = $inview\"><li data-ng-if=\"contadores\"><strong data-count-to=\"18\" data-duration=\"1\" data-count-from=\"0\">18</strong> communities</li><li data-ng-if=\"contadores\"><strong data-count-to=\"487\" data-duration=\"1\" data-count-from=\"0\">487</strong> families</li><li data-ng-if=\"contadores\"><strong data-count-to=\"2922\" data-duration=\"1\" data-count-from=\"0\">2922</strong> people</li><li data-ng-if=\"contadores\">in <strong data-count-to=\"4000\" data-duration=\"1\" data-count-from=\"0\">4000</strong> hectares</li></ul></div><div class=\"col\"><img src=\"../assets/images/suppliers_program_traceability.png\" alt=\"\"></div></div><div class=\"cuadro-center\"><div class=\"cuadro\"><p>The re-evolution of our Suppliers Program.</p><img src=\"../assets/images/icons/subrayado_frases.png\" alt=\"\" class=\"primero\"> <img src=\"../assets/images/icons/trazo_suppliers.png\" alt=\"\" class=\"ultimo\"></div></div><div class=\"acordeon\"><accordion close-others=\"oneAtATime\"><accordion-group heading=\"Nourishing the world of energy and well-being\" is-open=\"false\"><p>Our company grows, our brand re-evolves. We are stronger than ever, ready to leap into a new transformative future. We want to share our knowledge and energy to empower and nourish the world, while remaining –as always– steadfast protectors of our ancestral legacy, our people and our soil.</p><p>A visón of holistic empowerment is the driver of our fair pricing policy, guaranteeing our farmers fair payment of the quiona that they grow under the rigorous controls and quality we have established together.</p></accordion-group><accordion-group heading=\"Challenging commitment and sustainable processes\" is-open=\"false\"><p>The chemical composition of our soils converts the foods that we offer you in energy that nourishes: true nutritious products that are 100% suitable for vegans, gluten-free and non GMO, among other characteristics.</p><p>Our transparency is provable, as is the case with the 8 control stages that guarantee our traceability policy since the raw material leaves the fields, arrives in our plant and ends up on your table.</p><p>The farmers that work alongside us are trained and constantly receiving feedback and support from our technical staff to improve yields and ensure soil conservation of their lands.</p></accordion-group><accordion-group heading=\"Ancestral wisdom, progress for the future\" is-open=\"false\"><p>We grow with our communities guaranteeing an organic and sustainable process. Together with our farmers, every day, we stablish objectives to fight against the trust deficit in the organic quinoa production.</p><p>Texto final letras rojas: Nourishing the world of energy and well-being.</p></accordion-group></accordion></div></div></div>");
$templateCache.put("app/views/traceability.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"pagina traceability\" id=\"traceability\"><div class=\"banner\"><h2 class=\"titulo-banner\">TRACEABILITY</h2></div><div class=\"cont-timeline\" data-sr-container=\"{}\"><div class=\"cont-titulo\"><h2>From our farms to the fork.</h2><h2>From the fork to your heart.</h2></div><div class=\"all-timeline\"><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"titulo-exterior\"><h2>OUR FARMS</h2><img src=\"../assets/images/icons/subrayado_frases.png\" alt=\"\"></div><div class=\"col md8\"><h3>Soil tillage and fallow lands</h3></div><div class=\"col md4\"><img src=\"../assets/images/icons/quinoa_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter right over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>SOWING</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/quinoa_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>PLAGUE CONTROL</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/quinoa_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter right over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>HARVESTING</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/quinoa_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter right over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>STOOKING</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/quinoa_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>THRESHING</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/quinoa_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter right over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>CLEANING GRAINS AT ORIGIN</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/quinoa_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"titulo-exterior\"><h2>OUR FACILITIES</h2><img src=\"../assets/images/icons/subrayado_frases.png\" alt=\"\"></div><div class=\"col md8\"><h3>PACKAGING</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/empaque_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter right over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>TRANSPORT TO THE PLANT</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/empaque_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>RECEPTION WEIGHING AND SAMPLING</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/empaque_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter right over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>GRAIN MILLING</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/empaque_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>MANUFACTURING OF OUR VALUE ADDED PRODUCTS</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/empaque_trazabilidad.png\" alt=\"\"></div><div class=\"titulo-exterior\"><h2>TO THE FORK</h2><img src=\"../assets/images/icons/subrayado_frases.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>EXPORT</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/producto_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>GLOBAL DISTRIBUTION</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/producto_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"timeline-block\"><div class=\"center\" data-sr=\"enter left over 1s and move 100% after .9s\"><div class=\"col md8\"><h3>Nutrition of the soul. Healthy revolution</h3></div><div class=\"col md5\"><img src=\"../assets/images/icons/producto_trazabilidad.png\" alt=\"\"></div></div></div><div class=\"corazon\"></div></div></div><div class=\"your-heart\"><div class=\"center\"><h2>YOUR HEART</h2><img src=\"../assets/images/icons/subrayado_frases.png\" alt=\"\"> <img src=\"../assets/images/icons/trazo_corazon.svg\" alt=\"\" class=\"image-center\"></div></div><div class=\"quinoa\"><a data-smooth-scroll=\"\" target=\"traceability\" class=\"bt-arriba\"></a><div data-ng-repeat=\"i in [].constructor(6) track by $index\"><img src=\"../assets/images/icons/icon-quinoa-red.svg\" alt=\"\"></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/products/detalle.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"container-fluid pagina detalle\"><div class=\"options\"><div class=\"opt\"><div class=\"layer\"><p>See more products</p></div><div class=\"btn-group\" dropdown=\"\" is-open=\"status.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\" ng-disabled=\"disabled\">{{prod2.selected.catalias}}<span class=\"caret\"></span></button><ul class=\"dropdown-menu\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li data-ng-repeat=\"cat in prod2.productscat\"><a href=\"/products/{{cat.alias}}\">{{cat.nombre}}</a></li></ul></div><div class=\"btn-group\" dropdown=\"\" is-open=\"status.isopen2\"><button id=\"single-button2\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\" ng-disabled=\"disabled\">{{prod2.selected.prod}}<span class=\"caret\"></span></button><ul class=\"dropdown-menu\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li data-ng-repeat=\"item in prod2.products track by item.id\"><a data-ng-click=\"prod2.changeProd(item, $index);prod2.changeSlide($index)\">{{item.nombre}}</a></li></ul></div></div></div><ng-owl-carousel id=\"myCarousel\" data-ng-if=\"prod2.products\" class=\"owl-theme\" owl-items=\"prod2.products\" owl-properties=\"prod2.properties\" owl-ready=\"ready($api)\"><div class=\"item prod-content\" data-ng-repeat=\"item in prod2.products track by item.id\"><div class=\"features\"><div class=\"facts\" top-height=\"\" type2=\"true\"><h4 class=\"title\" data-ng-bind-html=\"item.nombre\"></h4><img class=\"subr\" src=\"../assets/images/icons/subrayado_frases.png\" alt=\"\"><p class=\"legend\" data-ng-bind=\"item.leyenda\"></p><div class=\"talk type1\"><p>Are you interested in this product?</p><h4>LET\'S TALK</h4><a ui-sref=\"contact\" class=\"bt-nav amarillo\">Contact us</a></div></div><div class=\"board\" top-height=\"\"><div class=\"board-box\" top-height=\"\"><div class=\"boardtext\"><p class=\"subtitle\">Ingredients</p><p class=\"text\" data-ng-bind-html=\"item.ingredientes\"></p><p class=\"subtitle\">Net content</p><p class=\"text\" data-ng-bind-html=\"item.contenido_neto\"></p><p class=\"subtitle\">Portion</p><p class=\"text\" data-ng-bind-html=\"item.porcion\"></p></div></div><div class=\"floating\" top-height=\"\"><img ng-src=\"{{item.imagen}}\" alt=\"\"></div></div></div><div class=\"clearfix\"></div><div class=\"tastys\"><div class=\"video\" data-ng-if=\"item.video\"><h4>TASTY\'S</h4><div class=\"box2\"><div class=\"video-prev\"><div class=\"embed-responsive-4by3\"><iframe ng-src=\"{{item.video | trusted}}\" frameborder=\"0\" allowfullscreen=\"\" ng-if=\"item.video!=null\"></iframe></div></div><p ng-if=\"item.video!=null\" ng-bind=\"item.video\"></p></div></div><div class=\"related\"><h4>Releated products</h4><div class=\"box2\" ng-if=\"prod2.products.length>0\"><img class=\"related-prev\" data-ng-click=\"prod2.changeSlide(0)\" ng-src=\"{{prod2.products[0].imagen}}\"><p ng-bind=\"prod2.products[0].nombre\"></p></div><div class=\"box2\" data-ng-click=\"prod2.changeSlide(1)\" ng-if=\"prod2.products.length>1\"><img class=\"related-prev\" ng-src=\"{{prod2.products[1].imagen}}\"><p ng-bind=\"prod2.products[1].nombre\"></p></div></div></div><div class=\"talk type2\"><p>Are you interested in this product?</p><h4>LET\'S TALK</h4><a href=\"\" class=\"bt-nav amarillo\">Contact us</a></div></div></ng-owl-carousel></div>");
$templateCache.put("app/views/products/products.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"container-fluid pagina products\"><div class=\"top-box\"><div class=\"quinua\" top-height=\"\"><div class=\"title\" top-height=\"\"><div class=\"titulo-banner amarillo\">\"Royal\"<br>Quinoa</div></div><div class=\"text\" top-height=\"\"><div class=\"text-box\"><h4>Do you know why our royal quinoa is the best type of quinoa in the world?</h4><img class=\"underline\" src=\"../assets/images/products/subrayado_frases.svg\" alt=\"Subrayado\"> <a href=\"http://www.andeanvalley.com/royal-quinoa\" class=\"bt-nav amarillo\">More</a></div></div></div></div><div class=\"bottom-box\"><ng-owl-carousel data-ng-if=\"prod.items\" class=\"owl-theme\" owl-items=\"prod.items\" owl-properties=\"prod.properties\" owl-ready=\"ready($api)\"><div class=\"item catprod\" bottom-height=\"\" data-ng-repeat=\"item in prod.items\"><figure class=\"effect-goliath\"><div class=\"img\" bottom-height-2=\"\" background=\"{{item.imagen}}\"></div><figcaption><p bottom-height=\"\" ui-sref=\"product({id:item.alias})\">{{item.nombre}} <a ui-sref=\"product({id:item.alias})\" class=\"bt-nav amarillo\">More</a></p></figcaption></figure></div></ng-owl-carousel></div></div>");
$templateCache.put("app/views/products/quinoa.html","<header data-ng-include=\"\" data-src=\"\'app/views/header.html\'\"></header><div class=\"pagina quinoa\"><div class=\"quinoa-banner row\"><div class=\"container\"><h1 class=\"titulo-bloque amarillo\">\"ROYAL\"<br>QUINOA</h1><div class=\"right\"><div class=\"highlighted\"><p>DO YOU KNOW WHY ROYAL<br>QUINOA IS THE BEST TYPE OF QUINOA<br>IN THE WORLD?</p></div><div class=\"cuadro-banner\"><div><p>From our very beginning as a company that just processed Royal Quinoa, we have always pushed our boundaries and kept innovation as our goal. We have walked this path with a strong sense of commitment and courage, and today we proudly offer our clients and consumers a wonderful range of 50 organic, gluten-free, non-GMO, no-coloring and no-preservatives products.</p></div></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h3 class=\"phrase\">We believe in our Royal Quinoa.<br>Amaze yourself with the wonderful qualities of Royal Quinoa</h3><p>Quinoa is a healthy, nutritious superfood that has been grown for thousands of years in the Andean countries of South America. At Andean Valley Corporation, we strive to preserve and share this ancestral legacy.</p></div></div><div class=\"accordion row\"><accordion close-others=\"oneAtATime\"><accordion-group heading=\"Native\" is-open=\"false\"><p>Royal Quinoa comes from originary seeds that have been kept intact and are grown by small local communities in Bolivia’s southern altiplano. Unlike the one from other countries, bolivian quinoa is not subject to any kind of biotechnological manipulation, and retains its unique ancestral properties.</p></accordion-group><accordion-group heading=\"Nutritious and healthy\" is-open=\"false\"><p>Since it’s grown from native seeds, the original quality of our Royal Quinoa remains untouched; this results in a more uniform set of nutritional properties.</p></accordion-group><accordion-group heading=\"Bigger grain\" is-open=\"false\"><p>Our Royal Quinoa is 3 to 4 times larger in diameter than the rest of quinoa varieties. This is an exceptional quality, highly esteemed in the gastronomical world</p></accordion-group><accordion-group heading=\"Gourmet universe\" is-open=\"false\"><p>Our Royal Quinoa exhibits several special properties as a raw material for the greatest chefs around the world.</p></accordion-group><accordion-group heading=\"Socially responsible\" is-open=\"false\"><p>Our Royal Quinoa is exclusively produced in the andean region of Bolivia, across the flatlands and hillsides surrounding the two largest salt lakes in the world. Small local communities, native to this land, continue to grow the grain, as they have done for generations.</p></accordion-group><accordion-group heading=\"Organic and gluten free\" is-open=\"false\"><p>Texto interior pestaña 6: the unique weather and particular soil properties of the altiplano are hostile to most kinds of crops, but give unparallelled benefits to the growth of Royal Quinoa. This type of quinoa evolved more than 6.000 years ago, adapting to the harsh local nature.</p><p>Texto cierre letras pequeñas: These properties merge into the distinctive and unique quality of our Royal Quinoa. To help you easily identify our quinoa, we have created the AUTHENTIC ROYAL QUINOA (RQ) seal, found in all of our products. It is a symbol of how much we value the attributes of our Royal Quinoa; it is a pledge of how committed we are with our customers’ health and well-being; it is an affirmation of our purpose to preserve the ancestral legacy of this wondrous type of quinoa; and it is a vouch to always keep it free of any biotechnological or genetic modification.</p></accordion-group></accordion><p class=\"footer-info\">These properties merge into the distinctive and unique quality of our Royal Quinoa. To help you easily identify our quinoa, we have created the AUTHENTIC ROYAL QUINOA (RQ) seal, found in all of our products. It is a symbol of how much we value the attributes of our Royal Quinoa; it is a pledge of how committed we are with our customers’ health and well-being; it is an affirmation of our purpose to preserve the ancestral legacy of this wondrous type of quinoa; and it is a vouch to always keep it free of any biotechnological or genetic modification.</p><div class=\"center-block contact-us col-xs-12 col-sm-10 col-md-8\"><h3 class=\"highlighted verde\">Ancestral wisdom progress of the future</h3><a ui-sref=\"contact\" class=\"button-contact button-trans\">Contact us</a></div></div></div></div>");}]);